// extracted by mini-css-extract-plugin
export var contactContainer = "index-module--contactContainer--TuHJX";
export var contactContentContainer = "index-module--contactContentContainer--iPMrF";
export var contactOthers = "index-module--contactOthers--iMWMP";
export var contactSocials = "index-module--contactSocials--cQMwh";
export var footerNav = "index-module--footerNav--kD9IS";
export var footerNavContainer = "index-module--footerNavContainer--VE7No";
export var formContainer = "index-module--formContainer--zJ9ir";
export var formMarker = "index-module--formMarker--WfNC7";
export var formPerson = "index-module--formPerson--X-ZVq";
export var formSend = "index-module--formSend--lCXiY";
export var headerContainer = "index-module--headerContainer--ukSCc";
export var headerLogoNav = "index-module--headerLogoNav--vmt6e";
export var headerNav = "index-module--headerNav--7IZI7";
export var hero = "index-module--hero--f3jJg";
export var heroAbout = "index-module--heroAbout--S4XgQ";
export var heroButtonContact = "index-module--heroButtonContact--h5niR";
export var heroButtonProjects = "index-module--heroButtonProjects--lFAA-";
export var heroButtons = "index-module--heroButtons--pBe0h";
export var heroConsole = "index-module--heroConsole----ZmH";
export var heroText = "index-module--heroText--sZRw-";
export var portfolioContainer = "index-module--portfolioContainer--Jihp4";
export var project = "index-module--project--BFV1P";
export var projectEven = "index-module--projectEven--UkDkY";
export var projectHeader = "index-module--projectHeader--q3kvX";
export var projectImage = "index-module--projectImage--idP7F";
export var projectLinks = "index-module--projectLinks--FkrpP";
export var projectMarker = "index-module--projectMarker--9aFXe";
export var projectText = "index-module--projectText--TzOkS";
export var projectTitle = "index-module--projectTitle--SnYjf";
export var projectTool = "index-module--projectTool--XVMkz";
export var projectTools = "index-module--projectTools--x0Vj4";
export var projects = "index-module--projects--1D0+a";
export var projectsButton = "index-module--projectsButton--birBG";
export var projectsContainer = "index-module--projectsContainer--8x-rz";
export var sectionTitle = "index-module--sectionTitle--ca1Pr";
export var skillsBox = "index-module--skillsBox--1Rcbp";
export var skillsContainer = "index-module--skillsContainer--Mfe9R";
export var skillsGroup = "index-module--skillsGroup--VByBx";
export var skillsMarker = "index-module--skillsMarker--U01+M";
export var swftlime = "index-module--swftlime--2Gj-7";
export var triangle = "index-module--triangle--R1fqW";
export var vl = "index-module--vl--tQSua";